import { Link } from '@backstage/ui';
import { RiShieldUserLine } from '@remixicon/react';

import styles from './AzureCard.module.css';

const PIM_AZURE_RESOURCES_URL =
  'https://portal.azure.com/#view/Microsoft_Azure_PIMCommon/ActivationMenuBlade/~/azurerbac';
const PIM_ENTRA_ROLES_URL =
  'https://portal.azure.com/#view/Microsoft_Azure_PIMCommon/ActivationMenuBlade/~/aadmigratedroles';

export type PimResourceType = 'subscriptions' | 'app registrations';

type AzurePimActivationProps = {
  resourceType: PimResourceType;
};

export const AzurePimActivation = ({ resourceType }: AzurePimActivationProps) => {
  return (
    <Link
      href={resourceType === 'subscriptions' ? PIM_AZURE_RESOURCES_URL : PIM_ENTRA_ROLES_URL}
      aria-label={`PIM activation for ${resourceType}`}
      target="_blank"
      rel="noreferrer"
      className={`${styles.link} ${styles.pimActivation}`}
      standalone
    >
      <RiShieldUserLine size={16} aria-hidden="true" focusable="false" />
      PIM activation
    </Link>
  );
};
